import Mapbox from '../helpers/mapbox';
import { bugsnagClient } from '@mrhenry/wp--bugsnag-config';

class MrLocationsMap extends HTMLElement {
	// Life cycle
	connectedCallback() {
		if ( !( 'IntersectionObserver' in window ) ) {
			return;
		}

		// Wait for first (or next) frame render
		window.requestAnimationFrame( () => {
			this.locations = [];

			this.elements = {};
			this.elements.userLocationButton = document.querySelector( '.js-locations-user' );

			this._observer = new IntersectionObserver( ( entries ) => {
				for ( let i = 0; i < entries.length; i += 1 ) {
					const entry = entries[i];

					if ( !entry || !entry.target ) {
						continue;
					}

					if ( entry.target === this && entry.isIntersecting ) {
						if ( this._didInitMap ) {
							return;
						}

						// Any errors that happen below are fatal and cannot be retried.
						// No point to set this to true after actually creating a map.
						this._didInitMap = true;

						if ( this._observer ) {
							this._observer.disconnect();
							this._observer = null;
						}

						this.initMap();
						break;
					}
				}
			} );

			this._observer.observe( this );
		} );
	}

	disconnectedCallback() {
		if ( this._observer ) {
			this._observer.disconnect();
			this._observer = null;
		}

		this.locations = [];
	}

	initMap() {
		Mapbox.loadDependencies().then( () => {
			this.trySetLocations();
		} ).catch( ( err ) => {
			console.warn( err );
			this.innerHTML = '<span style="user-select:none;"><br>&nbsp;&nbsp;❗️</span>';
		} );
	}

	trySetLocations() {
		try {
			const data = JSON.parse( this.getAttribute( 'locations' ) );
			this.locations = data;
		} catch ( err ) {
			console.dir( err );
			bugsnagClient.notify( err );
		}

		// XXX_SECRET
		window.mapboxgl.accessToken = 'pk.eyJ1IjoibXJoZW5yeS1jYXciLCJhIjoiY2swMmZqaHQxMWtuOTNocHJvZjE4NmNuaCJ9.B-z_srcerjH1h7vPiuPRDQ';

		this.renderMap();
	}

	renderMap() {
		const latitudes = this.locations.map( ( x ) => {
			return x.latitude;
		} );
		const longitudes = this.locations.map( ( x ) => {
			return x.longitude;
		} );
		const minLatitude = Math.min( ...latitudes );
		const maxLatitude = Math.max( ...latitudes );
		const minLongitude = Math.min( ...longitudes );
		const maxLongitude = Math.max( ...longitudes );

		const latitudeDelta = maxLatitude - minLatitude;
		const longitudeDelta = maxLongitude - minLongitude;

		const southWest = [
			minLongitude - ( longitudeDelta / 10 ),
			maxLatitude + ( latitudeDelta / 10 ),
		];

		const northEast = [
			maxLongitude + ( longitudeDelta / 10 ),
			minLatitude - ( latitudeDelta / 10 ),
		];

		const bounds = [
			southWest,
			northEast,
		];

		Mapbox.initializeMap( this, bounds ).then( ( map ) => {
			this.map = map;
		} ).then( () => {


			const geoJSON = Mapbox.buildGeoJSON( this.locations );
			Mapbox.renderMarkers( geoJSON, this.map );
			this.map.fitBounds( [
				southWest,
				northEast,
			], {
				animate: false,
			} );
		} );
	}
}

customElements.define( 'mr-locations-map', MrLocationsMap );
